import * as React from 'react';
import { Spin, Button, Row, Col } from 'antd';
import { PageProps } from "../../models/common/ComponentProps";
import bindAllOfThis from "../../utils/BindThisHelper";
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import OccupationDetailsDTO from 'src/models/occupation/OccupationDetailsDTO';
import OccupationApiController from 'src/api/OccupationApiController';
import { read } from 'fs';
import './OccupationDb.less';

interface RouteParams {
    id: string;
}

interface OccupationProps extends PageProps<RouteParams>, LocalizeContextProps { }

interface OccupationState {
    loading: boolean;
    currentOccupation: OccupationDetailsDTO;
}

class Occupation extends React.Component<OccupationProps, OccupationState> {
    constructor(props: OccupationProps) {
        super(props);
        bindAllOfThis(this, Occupation.prototype);

        let currentOccupation: OccupationDetailsDTO = {
            id: 0,
            title: "",
            description: "",
            entryLevelEducation: "",
            futureOutlook: "",
            entryEarnings: "",
            averageEarnings: "",
            hollandCode: "",
            skills: [],
            schoolSubjects: [],
            relatedJobs: []
        };

        this.state = {
            loading: true,
            currentOccupation: currentOccupation
        };
    }

    componentDidMount() {
        let occupationId = parseInt(this.props.match.params.id, 10);
        OccupationApiController.getOccupationDetails(occupationId, { additionalHeaders: { CultureCode: this.props.activeLanguage.code } }).then(result => {
            if (!result.ok) {
                return;
            }

            let occupationDetails = result.data;
            this.setState({
                loading: false,
                currentOccupation: occupationDetails
            });
        });
    }

    private handleCancel(e): void {
        let route = this.props.location.pathname.includes('admin') ? Routes.ADMIN_OCCUPATIONDB : Routes.OCCUPATIONDB;
        this.props.history.push(route);
    }

    private renderHollandCode() {
        return <div className="occupationSection">
            <strong>Holland Code:&nbsp;</strong>
            {this.state.currentOccupation.hollandCode}
        </div>;
    }

    private renderDescription() {
        if (this.state.currentOccupation.description) {
            return (<div className="occupationSection">
                <strong>Description:</strong>
                <div>{this.state.currentOccupation.description}</div>
            </div>);
        }
    }

    private renderFutureOutlook() {
        if (this.state.currentOccupation.futureOutlook) {
            return (<div className="occupationSection">
                <strong>Future Outlook:</strong>
                <div>{this.state.currentOccupation.futureOutlook}</div>
            </div>);
        }
    }

    private renderEntryEarnings() {
        if (this.state.currentOccupation.entryEarnings) {
            return (<div className="occupationSection">
                <strong>Typical Entry-level Earnings:</strong>
                <div>{this.state.currentOccupation.entryEarnings}</div>
            </div>);
        }
    }

    private renderAvgEarnings() {
        if (this.state.currentOccupation.averageEarnings) {
            return (<div className="occupationSection">
                <strong>Average Earnings:</strong>
                <div>{this.state.currentOccupation.averageEarnings}</div>
            </div>);
        }
    }

    private renderEntryLevelEdu() {
        if (this.state.currentOccupation.entryLevelEducation) {
            return (<div className="occupationSection">
                <strong>Typical Entry-Level Education:</strong>
                <div>{this.state.currentOccupation.entryLevelEducation}</div>
            </div>);
        }
    }

    private renderSkills() {
        if (this.state.currentOccupation.skills.length > 0) {
            return <div className="occupationSection">
                <strong>Skills</strong>
                {this.state.currentOccupation.skills.map(skill => <li>{skill}</li>)}
            </div>;
        }
    }

    private renderSchoolSubjects() {
        if (this.state.currentOccupation.schoolSubjects.length > 0) {
            return <div className="occupationSection">
                <strong>Important School Subjects</strong>
                {this.state.currentOccupation.schoolSubjects.map(subject => <li>{subject}</li>)}
            </div>;
        }
    }

    private renderRelatedOccupations() {
        if (this.state.currentOccupation.relatedJobs.length > 0) {
            return <div className="occupationSection">
                <strong>Related Occupations</strong>
                {this.state.currentOccupation.relatedJobs.map(relatedJob => <li>{relatedJob}</li>)}
            </div>;
        }
    }

    render() {
        if (this.state.loading) {
            return <Spin />;
        }

        return (
            <div className="occupationDb">
                <h2>
                    {this.state.currentOccupation.title}
                    <Button onClick={this.handleCancel}>
                        {this.props.translate("common.back")}
                    </Button>
                </h2>

                {this.renderHollandCode()}
                {this.renderDescription()}
                {this.renderEntryLevelEdu()}
                {this.renderFutureOutlook()}
                {this.renderEntryEarnings()}
                {this.renderAvgEarnings()}
                {this.renderSkills()}
                {this.renderSchoolSubjects()}
                {this.renderRelatedOccupations()}
            </div>
        );
    }
}



export default withLocalize(Occupation);



// WEBPACK FOOTER //
// ./src/pages/public/Occupation.tsx